module.exports = __webpack_public_path__ + "img/mannul_close_home.e39bac09.png";